import React, { useEffect, useState } from "react";
import { FiCalendar } from "react-icons/fi";
import { FiUser } from "react-icons/fi";
import { Link } from "react-router-dom";

interface Berita {
  id: number;
  judul: string;
  kategori: string;
  kategori_web: string;
  gambar: string;
  deskripsi: string;
  created_at: string;
  user?: {
    name: string;
  };
}

const NewsSection = () => {
  const [news, setNews] = useState<Berita[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const IconCalender = FiCalendar as React.FC<React.SVGProps<SVGSVGElement>>;
  const IconUser = FiUser as React.FC<React.SVGProps<SVGSVGElement>>;

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/berita?per_page=3`)
      .then((res) => res.json())
      .then((result) => {
        setNews(result.data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [API_BASE_URL]);

  const formatDate = (date: string) =>
    new Date(date).toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

  return (
    <section className=" py-16">
      <div className="max-w-[1440px] mx-auto px-5 xl:px-10">
        <div className="flex items-center gap-5 mb-10">
          <h2 className="text-[22px] lg:text-[28px] font-semibold text-red-500 font-bilbo whitespace-nowrap">BERITA TERKINI</h2>
          <div className="w-full h-[3px] bg-gray-600" />
        </div>

        {loading && <p className="text-center text-gray-400">Memuat berita...</p>}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {news.map((item) => (
            <div key={item.id} className="max-sm:bg-[#faf7f2] bg-white shadow-xl md:shadow-xl rounded-2xl overflow-hidden border border-white/10 hover:-translate-y-1 transition-all duration-300">
              <img src={item.gambar} alt={item.judul} className="w-full h-[180px] object-cover" />

              <div className="p-5">
                <div className="flex justify-between items-center mb-3 text-sm">
                  <span className="bg-red-500/20 text-red-600 px-3 py-1 rounded-md font-medium">{item.kategori}</span>
                  <div className="flex items-center gap-1 text-gray-600">
                    <IconCalender />
                    {formatDate(item.created_at)}
                  </div>
                </div>

                <Link to={`/news/detail/${item.id}`}>
                  <h3 className="text-[#131010] font-semibold text-base md:text-lg hover:text-red-600 transition">{item.judul}</h3>
                </Link>

                <div className="text-gray-400 text-sm line-clamp-2 mb-4" dangerouslySetInnerHTML={{ __html: item.deskripsi }} />

                <div className="flex items-center gap-2 text-gray-600 text-sm">
                  <IconUser />
                  {item.user?.name || "-"}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
